<section class="section section-start-now">
    <div class="container">
        <div class="card card-start-now">
            <div class="card-body">
                <div class="section-header center on-dark">
                    <div class="header-start">
                        <h2 class="title">Unleash the Power of No-Code App Development.</h2>
                        <h5 class="subtitle">Fill the form for complimentary workshop on how to build your mobile App
                        </h5>
                    </div>
                </div>
                <div>
                    <app-sign-up></app-sign-up>
                </div>
            </div>
        </div>
    </div>
</section>